<div
    #surface
    class="cm-surface"
    [class.cm-disabled]="$disabled()"
    [style.width]="$surfaceWidth()"
    [style.aspect-ratio]="$surfaceAspectRatio()"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerCancel($event)"
>
    <img class="cm-preview" [src]="$previewUrl()" alt="Reference image preview" draggable="false" />
    @if ($regionBox(); as regionBox) {
        <div class="cm-region" [style.left]="regionBox.left" [style.top]="regionBox.top" [style.width]="regionBox.width" [style.height]="regionBox.height">
            @for (corner of corners; track corner) {
                <div class="cm-handle cm-handle-{{ corner }}" [attr.data-corner]="corner"></div>
            }
        </div>
    }
</div>
